var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settings-conformity" },
    [
      _c("div", { staticClass: "typographies-heading-h2" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$t.__("settings.sellsymodule.invoicing.conformity.title")
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      !_vm.isConform
        ? _c("CompassAlert", {
            attrs: {
              description: _vm.$t.__(
                "settings.sellsymodule.invoicing.conformity.not_conform_alert"
              ),
              type: "warning",
              showIcon: false,
              showClose: false
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "settings-conformity__help" },
        [
          _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t.__(
                    "settings.sellsymodule.invoicing.conformity.information_text"
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("CompassLink", {
            attrs: {
              label: _vm.$t.__("common.labels.learn_more"),
              link: _vm.$t.__(
                "https://help.sellsy.com/fr/articles/5870717-conformite-des-documents-de-vente"
              ),
              target: "_blank"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("CompassSkeleton", { attrs: { variant: "block" } })
        : [
            _vm.isConform
              ? _c(
                  "div",
                  { staticClass: "settings-conformity__is-conform" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "typographies-heading-h4 settings-conformity__is-conform--title"
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t.__(
                                "settings.sellsymodule.invoicing.conformity.is_conform_title"
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "settings-conformity__is-conform--rules-container"
                      },
                      _vm._l(_vm.isConformRuleText, function(ruleText, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass:
                              "typographies-paragraph-medium-regular settings-conformity__is-conform--rule"
                          },
                          [
                            _c("CompassIcon", {
                              attrs: {
                                icon: "success-circle-fill",
                                type: "success"
                              }
                            }),
                            _vm._v(
                              "\n                    " +
                                _vm._s(ruleText) +
                                "\n                "
                            )
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.shouldDisplayActivatedInfo
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "settings-conformity__activated-data typographies-paragraph-medium-regular"
                          },
                          [
                            !!_vm.conformityData.activated_at
                              ? _c("div", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm._f("dateFormatter")(
                                          _vm.conformityData.activated_at,
                                          "NORMAL_DATE_TIME_WITH_DAY"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.textActivatedBy) +
                                  "\n                "
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "CompassTooltip",
                      {
                        attrs: {
                          content: _vm.contentTooltipDownloadDisabled,
                          disabled: _vm.downloadCertificateEnabled,
                          placement: "bottom-start"
                        }
                      },
                      [
                        _c("CompassButton", {
                          staticClass:
                            "settings-conformity__is-conform--download-certificate",
                          attrs: {
                            disabled: !_vm.downloadCertificateEnabled,
                            label: _vm.$t.__(
                              "settings.sellsymodule.invoicing.conformity.download_certificate"
                            )
                          },
                          on: { click: _vm.downloadCertificate }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "settings-conformity__is-not-conform" },
                  [
                    _c("CompassObject", {
                      attrs: {
                        label: _vm.$t.__(
                          "settings.sellsymodule.invoicing.conformity.not_conform_title"
                        ),
                        object: "document",
                        size: "small"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "CompassTooltip",
                      {
                        attrs: {
                          content: _vm.$t.__(
                            "common.labels.no_permissions_to_perform_this_action"
                          ),
                          disabled: _vm.iscreatable,
                          placement: "bottom-end"
                        }
                      },
                      [
                        _c("CompassButton", {
                          attrs: {
                            disabled: !_vm.iscreatable,
                            label: _vm.$t.__(
                              "settings.sellsymodule.invoicing.conformity.button_activate_conformity"
                            )
                          },
                          on: { click: _vm.handleActivateConformity }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }